/**
 * PostUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * PostUpdateReq
 */
export interface PostUpdateReq {
  /** 帖子ID */
  id: string
  /** 帖子标题 */
  title?: string
  /** 帖子内容 */
  text?: any
  /** 文件ID列表 */
  file_ids?: string[]
}

/**
 * PostUpdateReq Schema
 */
export const PostUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '帖子ID',
      format: 'string',
      type: 'string',
      label: '帖子ID',
    },
    title: {
      description: '帖子标题',
      format: '*string',
      type: 'string',
      label: '帖子标题',
    },
    text: {
      description: '帖子内容',
      format: '*string',
      type: 'text',
      label: '帖子内容',
    },
    file_ids: {
      description: '文件ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: '文件ID列表',
    },
  },
  required: ['id'],
  type: 'object',
}
